import Vue from "vue";
import { store } from "../store/store.js";
import Router from "vue-router";

import LoginPage from "@/views/Auth/Login";
import DashboardMain from "@/views/Dashboard/Main";

//Edit Profile
const EditProfileMain = () => import("@/views/Auth/Main");
import EditProfile from "@/views/Auth/EditProfile";

//Error Pages
import NotFound from "@/views/Error/SmallNotFound";
import PageNotFound from "@/views/Error/PageNotFound";

//Stock Opname
const StockOpnameMain = () => import("@/views/Dashboard/StockOpname/Main");
import StockOpname from "@/views/Dashboard/StockOpname/StockOpname";
import StockOpnameDetail from "@/views/Dashboard/StockOpname/StockOpnameDetail";
import RequestOpname from '@/views/Dashboard/StockOpname/RequestOpname'

//Highlight
const HighlightMain = () => import('@/views/Dashboard/Highlights/Main');
import Highlight from '@/views/Dashboard/Highlights/Highlight';

//Setting
const SettingMain = () => import('@/views/Dashboard/Settings/UserManagement/Main')
const SettingUserManagement = () => import('@/views/Dashboard/Settings/UserManagement/UserManagement')
const SettingUnitManagement = () => import('@/views/Dashboard/Settings/UnitManagement/UnitManagement')

Vue.use(Router);

const router = new Router({
	mode: "history",
	base: process.env.BASE_URL,
	routes: [
		//Login Path
		{
			path: "/",
			redirect: "/login",
		},
		{
			path: "/login",
			name: "Login",
			component: LoginPage,
			meta: {
				requiresAuth: false,
			},
		},

		//Edit Profile
		{
			path: "",
			component: DashboardMain,
			children: [
				{
				path: "/edit-profile",
				name: "EditProfile",
				component: EditProfile,
				meta: {
					requiresAuth: true,
					sidebar: true,
				},
				},
			],
		},

		
		//Dashboard Start
		{
			path: "/dashboard",
			name: "Dashboard",
			component: DashboardMain,
			children: [
				//Default Fallback
				{
					path: "",
					name: "Dashboard",
					component: NotFound,
				},

				//Highlights Start
				{
					path: 'highlight',
					component: HighlightMain,
					children : [
						{
							path : '',
							name : 'Highlight',
							component : Highlight
						}
					]
				},
				// Highlights End

				// Stock Opname
				{
					path: "stock-opname",
					component: StockOpnameMain,
					children: [
						{
							path: "",
							name: "StockOpname",
							component: StockOpname,
						},
						{
							path: "create",
							name: "StockOpnameRequest",
							component: RequestOpname,
						},
						{
							path: "detail/:id",
							name: "StockOpnameDetail",
							component: StockOpnameDetail,
						},
					],
				},
				// Stock Opname End

				// Settings
				{
					path : 'settings',
					component: SettingMain,
					children : [{
						path : 'user-management',
						name : 'SettingUserManagement',
						component : SettingUserManagement
					}, {
						path : 'unit-management',
						name : 'SettingUnitManagement',
						component : SettingUnitManagement
					}]
				},
			],
			meta: {
				requiresAuth: true,
			},
		},

		//Error 404 Page Not Found
		{
			path: "*",
			component: PageNotFound,
			meta: {
				requiresAuth: false,
			},
		},
	],
});

export default router;
